export const COLORS = {
    BLUE : '#003777',
    WHITE : '#FFFFFF',
    BLACK: '#000000',
    ALICE_BLUE: '#F4F7FC',
    HEXA_BLACK: '#212121'
}

